const ConnectionsGridView = () => {
  return null;
};

export default ConnectionsGridView;
